
import '../App.css';
import React, { useState, useEffect, useRef } from 'react';
import logo from '../logo.png'
import { useLocation, useNavigate } from 'react-router-dom';
import { db } from '../config';

import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style
import moment from 'moment/moment';
import { FaRegSquare, FaUserFriends } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa";
import ReactModal from 'react-modal';
import { toast } from 'wc-toast'
import Select, { components } from 'react-select';
import { add_icon, delete_icon } from '../assets/Icons';
import { IoIosCloseCircle } from "react-icons/io";
import { MdOutlineFeed } from "react-icons/md";
import { decrypt, encrypt } from '../Crypto';
//import { ToastContainer, toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';
import { GoCheckbox } from "react-icons/go";
import { connect } from 'react-redux';

import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm';

import axios from 'axios';
//import { Collapse } from 'react-collapse';
import { RiseLoader } from 'react-spinners';
import Collapsible from 'react-collapsible';
import { IoChevronBack } from 'react-icons/io5';
import { GrCheckbox } from "react-icons/gr";
import { SetId } from './redux/actions';
import BackDrop from './Backdrop';
import { VscThreeBars } from 'react-icons/vsc';
///import { CreditUsagePanel } from './CreditUsagePanel';
import LicensePlanTabs from './LicensePlanTabs';
import { Gift, Image, Info, RefreshCw, X } from 'lucide-react';
import CreditUsagePanel from './CreditUsagePanel';

import { Collapse } from "react-collapse";
import { FiImage, FiClock, FiSettings } from "react-icons/fi";

const override = `
display: block;
margin: 0 auto;
border-color: red;
alignSelf:center
`;


const button_color = '#F7941D'

const userdb = db.ref('userdb');

const devices_db = db.ref('devices');
const customerdb = db.ref('Sign_up');



// https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app

function Subscription({ items, SetId }) {


    const [aiOpen, setAiOpen] = useState(false);

    const AiSubItem = ({ icon, label, onClick }) => (
        <div
            onClick={onClick}
            style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 14,
                height: 52,
                paddingLeft: 18,
                paddingRight: 20,
                marginBottom: 8,
                borderRadius: 12,
                backgroundColor: "transparent",
            }}
        >
            <div
                style={{
                    width: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#9AA4B2",
                }}
            >
                {icon}
            </div>

            <span
                style={{
                    fontSize: label === "Create Images" ? 13 : 15,
                    fontWeight: 600,
                    lineHeight: "1",
                    color: "#9AA4B2",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                }}
            >
                {label}
            </span>
        </div>
    );

    const AiLeftSubMenuDesktop = () => {
        return (
            <div
                style={{
                    display: "flex",
                    width: width * 0.14,
                    //  alignSelf: "center",
                    marginTop: 8,
                    // justifyContent: "center", // center whole block
                    marginLeft: 52,
                }}
            >
                {/* inner aligned block */}

                {/* vertical line */}
                <div
                    style={{
                        width: 4,
                        backgroundColor: "#2E3642",
                        borderRadius: 4,
                        marginRight: 14,
                    }}
                />

                {/* menu items */}
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start", // text stays left aligned
                    }}
                >
                    <AiSubItem
                        icon={<FiImage />}
                        label="Create Images"
                        onClick={() => {
                            if (items.devices > 0) {
                                navigate("/AICreate")
                                // Do something if devices are available
                            }
                            else toast('Add a Boom Display Device before using Ai')
                        }}
                    />

                    <AiSubItem
                        icon={<FiClock />}
                        label="History"
                        onClick={() => navigate("/AIGenerator")}
                    />

                    <AiSubItem
                        icon={<FiSettings />}
                        label="Settings"
                        onClick={() => navigate("/AISetting")}
                    />
                </div>


            </div>
        );
    };


    const AiLeftSubMenuMobile = () => {
        return (
            <div
                style={{
                    display: "flex",
                    width: width * 0.35,
                    alignSelf: "center",
                    marginTop: 8,
                }}
            >
                {/* vertical line */}
                <div
                    style={{
                        width: 4,
                        backgroundColor: "#2E3642",
                        borderRadius: 4,
                        marginRight: 14,
                        marginLeft: 12,
                    }}
                />

                <div style={{ flex: 1 }}>
                    <AiSubItem
                        icon={<FiImage />}
                        label="Create Images"
                        onClick={() => navigate("/AICreate")}
                    />

                    <AiSubItem
                        icon={<FiClock />}
                        label="History"
                        onClick={() => navigate("/AIGenerator")}
                    />

                    <AiSubItem
                        icon={<FiSettings />}
                        label="Settings"
                        onClick={() => navigate("/AISetting")}
                    />
                </div>
            </div>
        );
    };

    function lastActive(dat) {
        let diff = moment(new Date()).diff(new Date(Number(dat)), 'minutes')
        diff = Math.abs(diff)

        // less than 5 minutes 

        if (diff <= 5) {
            return 'Online'
        }

        // less than 1 hour 

        else if (diff <= 60) {
            return 'Active 5 mins Ago'
        }

        // calculation in hour 

        else if (diff <= 1440) {
            return `${Math.trunc((diff / 60))} hours ago`
        }


        // calculation in day 
        else if (diff > 1440) {
            return `${Math.trunc(diff / (1440))} days ago`
        }

    }

    // green , #008550
    // yellow , #EFB700
    // red , #B71D13

    function lastActiveColor(dat) {
        let diff = moment(new Date()).diff(new Date(Number(dat)), 'minutes')
        diff = Math.abs(diff)

        // less than 5 minutes 

        if (diff <= 5) {
            return '#008550'
        }

        // less than 1 hour 

        else if (diff <= 60) {
            return '#EFB700'
        }

        // calculation in hour 

        else if (diff <= 1440) {
            return `#B71D13`
        }


        // calculation in day 
        else if (diff > 1440) {
            return `#B71D13`
        }

    }

    const [stripePromise, setStripePromise] = useState(null);
    const [clientSecret, setClientSecret] = useState(null)


    useEffect(() => {
        setStripePromise(loadStripe('pk_test_51RJcAaQGplLO7EtaACXGMM2VoqZ9tSxBC6ykBodcQchiLaN9HOUygWTj9k451Ooak3PfsDgxTMH2I5kJHPI08KFJ00LReg87x2'));
    }, []);


    // const {state} = useLocation();
    // const user_id = state.item
    // console.log ('ID',user_id)

    useEffect(() => {
        if (items.myid == null) {
            let obj = localStorage.getItem('display')
            if (obj != null) { obj = JSON.parse(obj); SetId(obj) }
            else { navigate('/') }
        }
    }, [items])

    const [licenses, setLicenses] = useState(0)

    const key = items.myid == null ? null : items.myid.id

    let curr = new Date().getTime();

    const navigate = useNavigate();

    const [devices, setDevices] = useState([])
    const [checked_devices, setCheckedDevices] = useState([])

    useEffect(() => {
        const subscribe = userdb.child(String(key)).child('devices').on('value', (snapshot) => {
            if (snapshot != null && snapshot.val() != null) {
                let arr = Object.values(snapshot.val());
                let temp = [];
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].name != undefined) temp.push(arr[i])
                }
                setDevices([...temp])
            }
            else {
                setDevices([])
            }
        })

        return () => subscribe()
    }, [key])


    useEffect(() => {
        const subscribe = customerdb.child(String(key)).child('license').on('value', (snapshot) => {
            if (snapshot != null && snapshot.val() != null) {
                setLicenses(snapshot.val())
            }
            else {
                setLicenses(0)
            }
        })

        return () => subscribe()
    }, [key])


    const [touched1, setTouched1] = useState(false);

    function toggleTouched1() {
        setTouched1(!touched1);
    }

    function handleMouseUp1() {
        // Handle smooth animation when clicking without holding
        setTimeout(() => {
            setTouched1(!touched1);
        }, 150);
    }

    const [add, setAdd] = useState(false)
    const [id, setId] = useState('')
    const [id2, setId2] = useState('')
    const [id3, setId3] = useState('')

    const ref1 = useRef()
    const ref2 = useRef()
    const ref3 = useRef()

    const [name, setName] = useState('')

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

    const [success, setSuccess] = useState(false)

    async function add_device() {
        if (name != '' && id != '' && id2 != '' && id3 != '') {
            let obj = {
                device: id + id2 + id3,
                name: encrypt(name),
                last: new Date().getTime()
            }
            console.log('My id ', obj.device)
            let snap = await userdb.child(String(key)).child('devices').orderByChild('name').equalTo(encrypt(name)).once('value')
            if (snap.val() == null) {

                let snapshot = await devices_db.child(String(obj.device)).once('value')

                if (snapshot.val() == null) {
                    toast('Such ID doesnot exist')
                }

                else {
                    if (snapshot.val().parent != undefined) {

                        if (snapshot.val().parent == key) toast('It is already in your device list')
                        else toast('It is already connected to other device !')
                    }

                    else {
                        let curr = new Date().getTime()
                        let creat = Number(snapshot.val().time)
                        let diff = moment(new Date(curr)).diff(new Date(creat), 'minutes')
                        console.log('Diff ', curr, diff, moment(new Date(curr)).diff(new Date(creat), 'hours'), moment(new Date(curr)).diff(new Date(creat), 'days'))
                        if (diff <= 5) {


                            let new_length = devices.length + 1;
                            const room = db.ref('Sign_up')
                            await room.child(String(key)).child(String('device_no')).set(new_length)


                            await devices_db.child(String(obj.device)).child('parent').set(String(key))
                            await userdb.child(String(key)).child('devices').child(String(obj.device)).set(obj)
                            setSuccess(true)
                            setId('')
                            setId2('')
                            setId3('')
                            setName('')
                            toast('Device is added')
                        }
                    }
                }

            }
            else {
                toast('This name already exist . Try another one ')
            }
        }
        else toast('Fill up fields properly')
    }

    const [delete_content, setDeleteContent] = useState(false)

    async function delet_content() {
        await devices_db.child(String(delete_content.device)).remove()

        let new_length = devices.length - 1;
        const room = db.ref('Sign_up')
        await room.child(String(key)).child(String('device_no')).set(new_length)

        await userdb.child(String(key)).child('devices').child(String(delete_content.device)).remove()
        toast('Content is deleted !')
        setDeleteContent(false)
    }

    function dat(str) {
        return new Date(str).getDate() + " " + months[new Date(str).getMonth()] + " " + new Date().getFullYear()
    }

    function mytim(str) {
        return moment(new Date(str)).format('hh:mm a').toString()
    }

    useEffect(() => {
        if (id.length == 3) ref2.current?.focus()
    }, [id])

    useEffect(() => {
        if (id2.length == 3) ref3.current?.focus()
    }, [id2])

    useEffect(() => {
        if (id3.length == 3) ref1.current?.focus()
    }, [id3])


    // For Feedback

    const [add_feed, setAdd_feed] = useState(false)

    const [payment, setPayment] = useState(false)
    const [delete_pay, setDeletePay] = useState(false)
    const [add_pay, setAddPay] = useState(false)

    const [currSubId, setCurrSubId] = useState(null)

    const [payment_loading, setPaymentLoading] = useState(false)


    function currentAmount() {
        let temp = [...devices]
        let count = 0;
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].pay == true) {
                count++;
            }
        }

        if (count > 0) count--;
        return Number(count * 12).toFixed(2);
    }

    function currentAmountAdd() {
        let temp = [...devices]
        let count = 0;
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].pay == true) {
                count++;
            }
        }

        if (count > 0) count++;
        return Number(12).toFixed(2);
    }

    async function gettingSecret() {
        toast('Please wait')
        const res = await axios.post('https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app/sub', { 'email': (items.myid.Email), 'price': (Exactquantity() * 12).toFixed(2) });
        const { client_secret, status, sub_id, cust_id } = res.data;
        console.log('Got secret ', res.data)
        setClientSecret(client_secret)
        setCurrSubId(sub_id)
        setPayment(true);
        setDeleteSubscribe(null)
    }

    async function gettingSecretAdd(device) {
        toast('Please wait')
        const res = await axios.post('https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app/sub', { 'email': (items.myid.Email), 'price': currentAmountAdd() });
        const { client_secret, status, sub_id, cust_id } = res.data;
        console.log('Got secret ', res.data)
        setClientSecret(client_secret)
        setCurrSubId(sub_id)
        setAddPay(device);
    }

    const [delete_subscribe, setDeleteSubscribe] = useState(null)

    async function gettingDeleteSecret(device) {

        if (Number(currentAmount()) > 0) {
            toast('Please wait')
            const res = await axios.post('https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app/sub', { 'email': (items.myid.Email), 'price': currentAmount() });
            const { client_secret, status, sub_id, cust_id } = res.data;
            console.log('Got secret ', res.data)
            setClientSecret(client_secret)
            setCurrSubId(sub_id)
            setDeletePay(device);
            toast('This device subscription has been deleted')
            setDeleteSubscribe(null)
        }
        // only one 
        else {
            console.log('Device ', device)
            await cancelSubscription()
            await userdb.child(String(key)).child('devices').child(String(device.device)).child('pay').remove()
            setDeletePay(false)
            toast('This device subscription has been deleted')
            setDeleteSubscribe(null)
        }
    }

    function make_payment() {
        make_marking_devices()
    }

    useEffect(() => {
        localStorage.setItem('devices', JSON.stringify([]))
    }, [])

    function saveStorage() {
        console.log('Saving ', checked_devices)
        let temp = [...checked_devices]
        localStorage.setItem('devices', JSON.stringify(temp))
    }

    useEffect(() => {
        saveStorage()
    }, [checked_devices])

    const [all_payment, setAllPayment] = useState(false)

    function ifChecked(device) {
        let arr = localStorage.getItem('devices')
        arr = arr == null ? [] : JSON.parse(arr)

        console.log('Checking ', arr)

        for (let i = 0; i < arr.length; i++) {
            if (arr[i].device == device && arr[i].checked == true) {
                console.log('Found ')
                return true;
            }
        }
        return false;
    }

    useEffect(() => {
        let temp = [...devices]
        for (let i = 0; i < temp.length; i++) {
            if (ifChecked(temp[i].device)) temp[i].checked = true;
            else temp[i].checked = false
        }
        setCheckedDevices([...devices])
    }, [devices])

    function checkedAll() {
        let temp = [...checked_devices]
        for (let i = 0; i < temp.length; i++) {
            if ((temp[i].free == undefined || temp[i].free == false) && (temp[i].pay == undefined || temp[i].pay == false) && (thirtydaysends(temp[i].device) > 7 * 1440)) temp[i].checked = true
        }
        setCheckedDevices([...temp])
        setSelect(true)
    }

    function UncheckedAll() {
        let temp = [...checked_devices]
        for (let i = 0; i < temp.length; i++) {
            if ((temp[i].free == undefined || temp[i].free == false) && (temp[i].pay == undefined || temp[i].pay == false)) temp[i].checked = false
        }
        setCheckedDevices([...temp])
        setSelect(false)
    }

    function check_single(ID) {
        let temp = [...checked_devices]
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].device == ID) temp[i].checked = true
        }
        setCheckedDevices([...temp])
    }

    function remove_single(ID) {
        let temp = [...checked_devices]
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].device == ID) temp[i].checked = false
        }
        setCheckedDevices([...temp])
    }


    function quantity() {
        let count = 0;
        let temp = [...checked_devices]
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].checked == true) {
                count++;
            }
        }
        return count;
    }

    function Exactquantity() {
        let count = 0;
        let temp = [...checked_devices]
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].checked == true || temp[i].pay == true) {
                count++;
            }
        }
        return count;
    }

    async function make_marking_devices() {
        await cancelSubscription()
        setAllPayment(false)
        let sign_db = db.ref('Sign_up')
        await sign_db.child(String(key)).child('sub_id').set(currSubId)
        let new_obj = { ...items.myid }
        new_obj.sub_id = currSubId
        SetId(new_obj)
        let temp = [...checked_devices]
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].checked == true) {
                await userdb.child(String(key)).child('devices').child(String(temp[i].device)).child('pay').set(true)
            }
        }
        UncheckedAll()
        setCurrSubId(null)
        setPayment(false)
    }

    function make_payment_delete() {
        make_delete()
    }

    async function make_delete() {
        await cancelSubscription()
        let sign_db = db.ref('Sign_up')
        await sign_db.child(String(key)).child('sub_id').set(currSubId)
        let new_obj = { ...items.myid }
        new_obj.sub_id = currSubId
        SetId(new_obj)
        await userdb.child(String(key)).child('devices').child(String(delete_pay.device)).child('pay').remove()
        setDeletePay(false)
    }

    async function add_new() {
        await cancelSubscription()
        let sign_db = db.ref('Sign_up')
        await sign_db.child(String(key)).child('sub_id').set(currSubId)
        let new_obj = { ...items.myid }
        new_obj.sub_id = currSubId
        SetId(new_obj)
        await userdb.child(String(key)).child('devices').child(String(add_pay.device)).child('pay').set(true)
        setAddPay(false)
    }


    const [select, setSelect] = useState(false)

    async function cancelSubscription() {
        if (items.myid.sub_id != undefined) {
            try {
                const response = await axios({
                    url: 'https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app/cancel',
                    method: 'post',
                    data: {
                        sub_id: String(items.myid.sub_id)
                    },
                });
                console.log('Cancel ', response.data)
            }
            catch (e) {

            }
        }
    }

    // cus_SH2y3DtPRjSy0d
    async function getSubscriptionPage() {
        if (items.myid.id != undefined) {
            try {
                const response = await axios({
                    url: 'https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app/portal',
                    method: 'post',
                    data: {
                        customer_mail: String(items.myid.Email),
                        customer_id: items.myid.customer_id
                    },
                });
                console.log('Cancel ', response.data)
            }
            catch (e) {

            }
        }
    }

    useEffect(() => {
        //  getSubscriptionPage()
    }, [])

    const [devices_times, setDevicesTimes] = useState([])

    async function getExactDates() {
        let temp = [...devices]
        let new_temp = []
        for (let i = 0; i < temp.length; i++) {
            let obj = await db.ref('devices').child(String(temp[i].device)).once('value')
            if (obj != null && obj.val() != null) {
                new_temp.push(obj.val())
            }
        }

        setDevicesTimes([...new_temp])
    }

    useEffect(() => {
        if (devices.length > devices_times.length) {
            getExactDates()
        }
        else if (devices.length < devices_times.length) {
            getExactDates()
        }
    }, [devices, devices_times])

    function trialEndsIn(dat) {
        let diff = moment(new Date()).diff(new Date(Number(dat)), 'minutes')
        diff = Math.abs(diff)

        diff = 7 * 1440 - diff

        // less than 5 minutes 

        if (diff <= 60) {
            return `${diff} minutes`
        }

        // calculation in hour 

        else if (diff <= 1440) {
            return `${Math.trunc((diff / 60))} hours`
        }


        // calculation in day 
        else if (diff > 1440) {
            return `${Math.trunc(diff / (1440))} days`
        }

    }


    function thirtydaysends(id) {
        let now = new Date()
        let device_temp = 0;
        for (let i = 0; i < devices_times.length; i++) {
            if (devices_times[i].device == id) {
                device_temp = devices_times[i].time
            }
        }
        let diff = moment(now).diff(new Date(Number(device_temp)), 'minutes')
        // console.log('Days ', diff)
        return Math.abs(diff);
    }

    function trialends(id) {
        let now = new Date()
        let device_temp = 0;
        for (let i = 0; i < devices_times.length; i++) {
            if (devices_times[i].device == id) {
                device_temp = devices_times[i].time
            }
        }
        let diff = moment(new Date(Number(device_temp))).add(1, 'minutes')
        diff = new Date(diff)

        //diff = 60-diff

        return trialEndsIn(diff);
    }



    const [time, setTime] = useState(Date.now())

    useEffect(() => {
        const interval = setInterval(() => setTime(Date.now()), 1000 * 120)
        return () => {
            clearInterval(interval)
        }
    }, [])

    const [full_time, setFullTime] = useState(false)

    function numberogPay() {
        let temp = 0;
        for (let i = 0; i < devices.length; i++) {
            if (devices[i].pay == true) temp++;
        }
        return temp;
    }

    async function add_pay_checked(device) {
        if (licenses > numberogPay()) {
            await userdb.child(String(key)).child('devices').child(String(device)).child('pay').set(true)
            toast('Data updated')
        }
        else {
            toast('It will exceed the number of licenses.')
        }
    }

    async function remove_pay(device) {
        await userdb.child(String(key)).child('devices').child(String(device)).child('pay').set(false)
        toast('Data updated')
        setDeleteSubscribe(null)
    }

    function number_of_used() {
        let count = 0;
        for (let i = 0; i < devices.length; i++) {
            if (devices[i].pay == true) {
                count++;
            }
        }
        return count;
    }

    async function getUrl() {
        console.log('Getting url ')
        let customer_id = await customerdb.child(String(key)).child('customer_id').once('value')
        if (customer_id.val() != null) {
            customer_id = customer_id.val()
            let obj = await fetch(`https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app/getUrl?cust_id=${customer_id}`)
            try {
                obj = await obj.json()
                if (obj.url != undefined) {
                    window.location.replace(obj.url, 'mywindow')

                }
                console.log('Customer id ', obj)
            }
            catch {
                toast('Something is wrong')
            }
        }
    }

    const [width, setwidth] = useState(window.innerWidth);
    const [height, setWindowHeight] = useState(window.innerHeight);

    useEffect(() => {
        const windowSizeHandler = () => {
            setwidth(window.innerWidth)
            setWindowHeight(window.innerHeight)
        };
        window.addEventListener("resize", windowSizeHandler);

        return () => {
            window.removeEventListener("resize", windowSizeHandler);
        };
    }, []);

    const isMobile = width <= 768;
    const drawerW = isMobile ? width * 0.80 : width * 0.20;

    // ✅ 3) One-line titles in mobile drawer
    const mobileDrawerTitleStyle = (maxW) => ({
        color: "white",
        marginLeft: 18,
        fontWeight: "600",
        fontSize: 15,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: maxW,
        display: "block",
    });

    const [drawerOpen, setDrawerOpen] = useState(false);

    function handleOpenDrawerButton() {
        setDrawerOpen(!drawerOpen);
    }

    function handleBackdropClick() {
        setDrawerOpen(false);
    }


    let drawerClasses = drawerOpen ? "side-drawer open" : "side-drawer";


    const [credit, setCredit] = useState(0)

    useEffect(() => {
        const subscribe = userdb.child(String(key)).child('credit').on('value', (snap) => {
            if (snap != undefined && snap.val() != null) {
                setCredit(snap.val())
            }
            else if (snap != undefined) {
                setCredit(15)
            }
        })
        return () => subscribe()
    }, [key])

    // create-credit-session
    // https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app

    async function openCreditPage() {
        fetch(`https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app/create-credit-session?userId=${key}`)
            .then(res => res.json())
            .then(data => {
                window.location.href = data.url; // ✅ same tab
            });

    }

    const [active_tab, setActiveTab] = useState("Device Licenses");
    const [open, setOpen] = useState(false);

    function CreditInfoModal({ onClose }) {
        return (
            <div style={styles.overlay}>
                <div style={styles.modal}>
                    {/* Header */}
                    <div style={styles.modalHeader}>
                        <h3 style={styles.modalTitle}>Credit Usage</h3>
                        <X
                            size={20}
                            style={styles.closeIcon}
                            onClick={onClose}
                        />
                    </div>

                    {/* Content */}
                    <div style={styles.rules}>
                        <div style={styles.rule}>
                            <Gift size={18} />
                            <span>
                                Every user receives <strong>15 free credits</strong>.
                            </span>
                        </div>

                        <div style={styles.rule}>
                            <Image size={18} />
                            <span>
                                Creating <strong>1 AI image</strong> costs <strong>1 credit</strong>.
                            </span>
                        </div>

                        <div style={styles.rule}>
                            <RefreshCw size={18} />
                            <span>
                                <strong>2 image regenerations</strong> cost <strong>1 credit</strong>.
                            </span>
                        </div>
                    </div>

                    {/* Button */}
                    <button style={styles.closeBtn} onClick={onClose}>
                        GOT IT
                    </button>
                </div>
            </div>
        );
    }

    const styles = {
        /* White Badge */
        badge: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 10,
            backgroundColor: "#FFFFFF",
            border: "1px solid #E5E7EB",
            borderRadius: 12,
            padding: "2px 3px",
            minWidth: 120,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            cursor: 'pointer'
        },

        creditText: {
            display: "flex",
            flexDirection: "column",
            textAlign: "left",
            fontSize: 13,
            color: "#6B7280", // gray-500
        },

        creditNumber: {
            fontSize: 18,
            fontWeight: 700,
            color: "#B45309", // brown/orange tone
        },

        infoBtn: {
            width: 30,
            height: 30,
            borderRadius: "50%",
            backgroundColor: "#F3F4F6",
            color: "#374151",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
        },

        /* Modal (unchanged, dark) */
        overlay: {
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.75)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
        },

        modal: {
            width: "90%",
            maxWidth: 420,
            background: "#0B0F14",
            borderRadius: 16,
            padding: 24,
            border: "2px solid #F7941D",
            color: "#fff",
            boxSizing: "border-box",
        },

        modalHeader: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 18,
        },

        modalTitle: {
            fontSize: 20,
            fontWeight: 700,
        },

        closeIcon: {
            cursor: "pointer",
            color: "#9CA3AF",
        },

        rules: {
            display: "flex",
            flexDirection: "column",
            gap: 14,
            marginBottom: 24,
        },

        rule: {
            display: "flex",
            alignItems: "flex-start",
            gap: 10,
            fontSize: 15,
            color: "#E5E7EB",
            lineHeight: "1.5em",
        },

        closeBtn: {
            width: "100%",
            height: 46,
            borderRadius: 10,
            border: "none",
            backgroundColor: "#F7941D",
            fontSize: 16,
            fontWeight: 700,
            cursor: "pointer",
            color: "#000",
        },
    };

    const [myimages, setMyImages] = useState(0)
    const [regen, setRegen] = useState(0)
    const [load, setLoad] = useState(false)

    useEffect(() => {
        const subscribe = db.ref('generated_image').child(String(key)).on('value', async (snap) => {
            if (snap != undefined && snap.val() != null) {
                let arr = Object.values(snap.val())
                let temp = 0;
                let total = 0;
                for (let i = 0; i < arr.length; i++) {
                    temp = (await db.ref('regenerated').child(String(key)).child(String(arr[i].image_id)).once('value')).numChildren()
                    total += temp;
                }
                setMyImages(arr.length)
                setRegen(total)
                setLoad(true)
            }
            else if (snap != undefined) {
                setMyImages(0)
                setRegen(0)
                setLoad(true)
            }
        })
        return () => subscribe()
    }, [key])

    return (
        !isMobile ? <div style={{ backgroundColor: '#080A0C', display: 'flex', flexDirection: 'row', width: width, height: height, position: 'absolute', top: 0, left: 0 }}>


            <div style={{ backgroundColor: '#080A0C', position: 'absolute', top: 0, left: 0, display: 'flex', flexDirection: 'column', height: height, width: width * 0.20, textAlign: 'center' }}>


                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#080A0C", width: width * 0.20, height: 100, justifyContent: 'center', alignItems: 'center' }}>
                    <img
                        src={logo}
                        alt="Logo"
                        style={{ width: 113, marginTop: 1, height: 53, alignSelf: 'center' }}
                    />
                </div>

                {items.show_welcome ? <div onClick={() => navigate('/Welcome')} style={{ cursor: 'pointer', marginTop: 20, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

                    <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Welcome</text>
                        <div style={{ height: 41, width: 20 }} />
                    </div>
                </div> : null}


                <div onClick={() => navigate('/Devices')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>
                    <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Devices</text>
                        <div style={{ height: 41, width: 20 }} />
                    </div>
                </div>

                <div onClick={() => navigate('/Content')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

                    <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Content</text>
                        <div style={{ height: 41, width: 20 }} />
                    </div>
                </div>

                <div onClick={() => navigate('/Calendars')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>
                    <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Calendar</text>
                        <div style={{ height: 41, width: 20 }} />
                    </div>
                </div>

                <div
                    onClick={() => setAiOpen(!aiOpen)}
                    style={{
                        cursor: "pointer",
                        marginTop: 5,
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                        width: 0.18 * width,
                        padding: 10,
                        alignSelf: "center",
                        alignItems: "center",
                        height: 52,
                    }}
                >
                    <div
                        style={{
                            width: 0.14 * width,
                            flexDirection: "row",
                            display: "flex",
                            padding: 10,
                            borderRadius: 6,
                            height: 52,
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <text style={{ color: "white", marginLeft: 30, fontWeight: "600", fontSize: 16 }}>
                            AI Generator
                        </text>

                        <img
                            src={require("../assets/right.png")}
                            style={{
                                height: 41,
                                width: 20,
                                transform: aiOpen ? "rotate(90deg)" : "rotate(0deg)",
                                transition: "transform 200ms ease",
                            }}
                        />
                    </div>
                </div>

                <Collapse isOpened={aiOpen}>
                    <AiLeftSubMenuDesktop />
                </Collapse>

                <div style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>
                    <div style={{ position: 'relative', backgroundColor: '#181E25', width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Subscription</text>
                        <img src={require('../assets/right.png')} style={{ height: 41, width: 20 }} />
                        {items.unlicensed > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: 'red', top: 5, left: 5 }}>
                            <text style={{ color: 'red', fontSize: 13 }}>{items.unlicensed}</text>
                        </div>}
                        {items.trial > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: '#F7941D', top: 5, right: 20 }}>
                            <text style={{ color: '#F7941D', fontSize: 13 }}>{items.trial}</text>
                        </div>}

                    </div>
                </div>


                <div onClick={() => navigate('/Settings')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

                    <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Settings</text>
                        <div style={{ height: 41, width: 20 }} />
                    </div>
                </div>

            </div>


            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: width * 0.20, width: width * 0.80, position: 'absolute', top: 0, height: height, backgroundColor: '#181E25', alignItems: 'flex-end' }}>

                <div style={{ display: 'flex', minHeight: 100, width: width * 0.7991, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C' }}>

                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: (width * 0.74) - 105 }}>
                        <text style={{ marginLeft: 0, fontSize: 24, fontWeight: '700', letterSpacing: 1.01, color: 'white', textAlign: 'center' }}>Subscription</text>

                        <div style={{ marginLeft: 6, marginTop: 4 }}>
                            <stripe-buy-button
                                buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                                publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
                            >
                            </stripe-buy-button>
                        </div>
                    </div>

                    <div onClick={() => {
                        navigate('/');
                        localStorage.removeItem('display')
                        localStorage.removeItem('devices')
                        SetId(null)
                    }} style={{ cursor: 'pointer', alignSelf: 'center', width: 105, height: 36, borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderWidth: 1, borderStyle: 'solid', borderColor: '#F7941D' }}>
                        <text style={{ color: '#F7941D', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Log out</text>
                    </div>
                </div>

                <div style={{ display: 'flex', alignSelf: 'center', width: '90%', marginTop: 10 }}>
                    <LicensePlanTabs
                        activeTab={active_tab}
                        setActiveTab={setActiveTab}
                    />
                </div>


                <Collapsible transitionTime={500} open={all_payment == false && active_tab == 'Device Licenses'}>
                    <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#181E25', width: width * 0.80, height: height - 180 }}>


                        <div style={{ width: 0.74 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 20, backgroundColor: '#F7941D', borderRadius: 12 }}>


                            <div style={{ width: 0.73 * width, height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', }}>

                                <div style={{ width: Math.max(350, 0.10 * width), height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center' }}>

                                    <div style={{ borderRadius: 10, backgroundColor: '#FFFFFF', cursor: 'pointer', display: 'flex', width: 340, height: 46, justifyContent: 'space-around', alignItems: 'center' }}>
                                        <text style={{ fontWeight: '700', fontSize: 15, color: 'black' }}>{licenses} License{`(s)`} Available</text>
                                        <div style={{ height: 28, width: 2, backgroundColor: 'black' }} />
                                        <text style={{ fontWeight: '700', fontSize: 15, color: 'black' }}>{number_of_used()} License{`(s)`} Used</text>
                                    </div>



                                </div>

                                <div style={{ width: 150, height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center' }}>



                                    <div onClick={() => {

                                        if (licenses > 0) {
                                            getUrl()
                                            // window.open('https://billing.stripe.com/p/login/test_7sY9AV3Mc3VZdUb2Uk7Zu00', 'mywindow').focus()
                                        }
                                        else {

                                            window.location.replace('https://buy.stripe.com/fZu9ATcsr6QE6XUgbLcQU01', 'mywindow')
                                        }

                                    }} style={{ cursor: 'pointer', display: 'flex', width: 140, height: 46, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>

                                        <text style={{ fontWeight: '600', fontSize: 15, color: 'black', marginLeft: 15 }}>{licenses > 0 ? 'Manage' : 'Purchase'} Subscriptions</text>
                                    </div>



                                </div>

                            </div>
                        </div>




                        <div style={{ width: 0.74 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 20 }}>


                            <div style={{ display: 'flex', height: 51, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                <div style={{ display: 'flex', height: 51, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                                    <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Device Name</text>
                                </div>
                            </div>


                            <div style={{ display: 'flex', height: 51, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                <div style={{ display: 'flex', height: 51, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                                    <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>ID Number</text>
                                </div>
                            </div>


                            <div style={{ display: 'flex', height: 51, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                <div style={{ display: 'flex', height: 51, width: 0.10 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                                    <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Last Online</text>
                                </div>
                            </div>



                            <div style={{ display: 'flex', height: 51, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                <div style={{ display: 'flex', height: 51, width: 0.07 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                                    <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>License</text>
                                </div>
                            </div>

                            <div style={{ display: 'flex', height: 51, width: 0.18 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                <div style={{ display: 'flex', height: 51, width: 0.16 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                                    <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Manage Subscription</text>
                                </div>
                            </div>
                        </div>



                        <div style={{ width: 0.74 * width, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 0, overflowY: 'auto', maxHeight: 1200, overflowX: 'hidden', }}>
                            {devices.map((item, id) => <div style={{ width: 0.74 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 10 }}>


                                <div style={{ display: 'flex', height: 56, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                                        <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>{item.name != undefined ? decrypt(item.name) : null}</text>
                                    </div>
                                </div>


                                <div style={{ display: 'flex', height: 56, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                                        <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>{item.device}</text>
                                    </div>
                                </div>


                                <div style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                        <div style={{ width: 16, height: 16, borderRadius: 10, backgroundColor: lastActiveColor(item.last) }} />
                                        <text style={{ color: 'white', fontSize: 17, fontWeight: '600', textAlign: 'left', alignSelf: 'center', marginLeft: 6 }}>{lastActive(Number(item.last))}</text>

                                    </div>
                                </div>


                                <div style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                    <div onClick={() => {
                                        if (item.free == false || item.free == undefined) {
                                            if (item.pay == true) {
                                                // remove_pay(item.device)
                                                setDeleteSubscribe(item)
                                            }
                                            else {
                                                add_pay_checked(item.device)
                                            }
                                        }
                                        else {
                                            toast('This one is free')
                                        }
                                    }} style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.07 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                                        <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>{(item.pay == true || item.free == true) ? <GoCheckbox size={25} color='#3ab549' /> : <FaRegSquare size={25} color='#F7941D' />}</text>
                                    </div>
                                </div>

                                <div onClick={() => { }} style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.18 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                                    {thirtydaysends(item.device) >= 7 * 1440 ? <div style={{ display: 'flex', height: 56, width: 0.16 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                        {((item.free == undefined || item.free == false) && (item.pay == undefined || item.pay == false)) ? <text style={{ color: 'red', fontWeight: '800', fontSize: 18 }}>Unlicensed</text>
                                            : <text style={{ color: '#F7941D', fontSize: 15, fontWeight: '700', textAlign: 'center', fontFamily: 'Poppins' }}>
                                                {item.free == true ? <text style={{ color: '#3ab549', fontWeight: '800', fontSize: 20 }}>Free</text> :

                                                    <text style={{ color: '#3ab549', fontWeight: '800', fontSize: 20, marginRight: 4, alignSelf: 'flex-start', textAlign: 'left' }}>Licensed</text>

                                                }
                                            </text>}
                                    </div>

                                        : <div style={{ display: 'flex', height: 56, width: 0.16 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>



                                            {((item.free == undefined || item.free == false) && (item.pay == undefined || item.pay == false)) ? <div onClick={() => { }} style={{ cursor: 'pointer', alignSelf: 'center', width: 125, height: 36, borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderWidth: 0, borderStyle: 'solid', borderColor: '#F7941D', marginLeft: 5 }}>

                                                {(item.pay == undefined || item.pay == false) && <text style={{ color: '#F7941D', fontSize: 13, fontWeight: '700', textAlign: 'center', fontFamily: 'Poppins' }}>
                                                    Trial - {trialends(item.device)} left
                                                </text>}

                                            </div> : <text style={{ color: '#F7941D', fontSize: 15, fontWeight: '700', textAlign: 'center', fontFamily: 'Poppins' }}>
                                                {item.free == true ? <text style={{ color: '#3ab549', fontWeight: '800', fontSize: 20 }}>Free</text> : <div style={{ cursor: 'pointer', alignSelf: 'center', width: 105, height: 36, borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderWidth: 1, borderStyle: 'solid', borderColor: '#F7941D', marginLeft: 5 }}>
                                                    <text style={{ color: '#F7941D', fontSize: 13, fontWeight: '600', textAlign: 'center' }}>Delete</text>
                                                </div>}
                                            </text>}
                                        </div>}

                                </div>

                            </div>)}
                        </div>


                    </div>
                </Collapsible>

                {open && <CreditInfoModal onClose={() => setOpen(false)} />}


                <Collapsible transitionTime={500} open={all_payment == false && active_tab != 'Device Licenses'}>
                    <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#181E25', width: width * 0.80, height: height - 180 }}>


                        <div style={{ width: 0.74 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 20, backgroundColor: '#F7941D', borderRadius: 12 }}>


                            <div style={{ width: 0.73 * width, height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', }}>

                                <div style={{ width: Math.max(350, 0.10 * width), height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center' }}>

                                    <div style={{ borderRadius: 10, backgroundColor: '#FFFFFF', cursor: 'pointer', display: 'flex', width: 340, height: 46, justifyContent: 'space-around', alignItems: 'center' }}>
                                        <text style={{ fontWeight: '600', fontSize: 15, color: 'black' }}>{credit} Credit(s) available</text>
                                        <div style={{ height: 28, width: 2, backgroundColor: 'black' }} />
                                        <text style={{ fontWeight: '600', fontSize: 15, color: 'black' }}>Info</text>
                                        <div
                                            style={{
                                                width: 30,
                                                height: 30,
                                                borderRadius: "50%",
                                                backgroundColor: "#F3F4F6",
                                                color: "#374151",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => setOpen(true)}
                                            title="How credits work"
                                        >
                                            <Info size={16} />
                                        </div>
                                    </div>



                                </div>

                                <div style={{ width: 150, height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center' }}>

                                    <div onClick={() => {
                                        openCreditPage()
                                    }} style={{ cursor: 'pointer', display: 'flex', width: 140, height: 46, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>

                                        <text style={{ fontWeight: '600', fontSize: 15, color: 'black', marginLeft: 15 }}>Buy Credits</text>
                                    </div>



                                </div>

                            </div>



                        </div>

                        <CreditUsagePanel
                            loading={load}
                            width={width}
                            credit={credit}
                            createdList={myimages}   // your create list array
                            regenList={regen} // your regen list array
                        />


                    </div>
                </Collapsible>

                <Collapsible transitionTime={500} open={all_payment}>
                    <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#181E25', width: width * 0.80, height: height - 200 }}>


                        <div style={{ width: 0.74 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 20, backgroundColor: '#F7941D', borderRadius: 12 }}>


                            <div style={{ width: 0.73 * width, height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', }}>

                                <div style={{ width: 0.17 * width, height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center' }}>

                                    <div onClick={() => { setAllPayment(false) }} style={{ cursor: 'pointer', display: 'flex', width: 150, height: 46, justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <IoChevronBack size={20} color='black' />

                                        <text style={{ fontWeight: '600', fontSize: 18, color: 'black', marginLeft: 8 }}>Back</text>
                                    </div>

                                    <div style={{ cursor: 'pointer', display: 'flex', width: 220, height: 46, justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <text style={{ fontWeight: '800', color: 'white', fontSize: 18 }}>My Cart</text>
                                    </div>


                                </div>

                                <div style={{ width: 350, height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center' }}>

                                    <div onClick={() => { if (select) { UncheckedAll() } else checkedAll() }} style={{ cursor: 'pointer', display: 'flex', width: 170, height: 46, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                                        {select ? <GoCheckbox size={25} color='#F7941D' /> : <GrCheckbox size={20} color='#F7941D' />}
                                        <text style={{ fontWeight: '600', fontSize: 18, color: 'black', marginLeft: 15 }}>All Devices</text>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div style={{ width: 0.74 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 20 }}>


                            <div style={{ display: 'flex', height: 51, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                <div style={{ display: 'flex', height: 51, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                                    <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Device Name</text>
                                </div>
                            </div>


                            <div style={{ display: 'flex', height: 51, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                <div style={{ display: 'flex', height: 51, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                                    <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>ID Number</text>
                                </div>
                            </div>


                            <div style={{ display: 'flex', height: 51, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                <div style={{ display: 'flex', height: 51, width: 0.10 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                                    <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Last Online</text>
                                </div>
                            </div>



                            <div style={{ display: 'flex', height: 51, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                <div style={{ display: 'flex', height: 51, width: 0.07 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                                    <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Price</text>
                                </div>
                            </div>

                            <div style={{ display: 'flex', height: 51, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                <div style={{ display: 'flex', height: 51, width: 0.07 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                                    <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Checked</text>
                                </div>
                            </div>


                        </div>



                        <div style={{ width: 0.74 * width, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 0, overflowY: 'auto', maxHeight: 600, overflowX: 'hidden', }}>
                            {checked_devices.map((item, id) => <div style={{ width: 0.74 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 10 }}>


                                <div style={{ display: 'flex', height: 56, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                                        <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>{item.name != undefined ? decrypt(item.name) : null}</text>
                                    </div>
                                </div>


                                <div style={{ display: 'flex', height: 56, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                                        <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>{item.device}</text>
                                    </div>
                                </div>


                                <div style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                        <div style={{ width: 16, height: 16, borderRadius: 10, backgroundColor: lastActiveColor(item.last) }} />
                                        <text style={{ color: 'white', fontSize: 17, fontWeight: '600', textAlign: 'left', alignSelf: 'center', marginLeft: 6 }}>{lastActive(Number(item.last))}</text>

                                    </div>
                                </div>


                                <div style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.07 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                                        <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>£12.00</text>
                                    </div>
                                </div>

                                <div style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                                    {thirtydaysends(item.device) >= 7 * 1440 ? <div style={{ display: 'flex', height: 56, width: 0.07 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                                        {((item.free == undefined || item.free == false) && (item.pay == undefined || item.pay == false)) ? <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>
                                            {item.checked ? <GoCheckbox onClick={() => { remove_single(item.device) }} size={25} color='#F7941D' /> : <GrCheckbox onClick={() => { check_single(item.device) }} size={23} color='#F7941D' />}
                                        </text> : <text style={{ color: '#F7941D', fontSize: 15, fontWeight: '700', textAlign: 'center', fontFamily: 'Poppins' }}>
                                            {item.free == true ? <text style={{ color: 'white' }}>Free</text> : 'Already Licensed'}
                                        </text>}
                                    </div>

                                        : <div style={{ display: 'flex', height: 56, width: 0.07 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                                            <text style={{ color: '#F7941D', fontSize: 13, fontWeight: '700', textAlign: 'center', fontFamily: 'Poppins' }}>
                                                Trial ends in {` ${1 - thirtydaysends(item.device)} hours`}
                                            </text>

                                            {((item.free == undefined || item.free == false) && (item.pay == undefined || item.pay == false)) ? <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>
                                                {item.checked ? <GoCheckbox onClick={() => { remove_single(item.device) }} size={25} color='#F7941D' /> : <GrCheckbox onClick={() => { check_single(item.device) }} size={23} color='#F7941D' />}
                                            </text> : <text style={{ color: '#F7941D', fontSize: 15, fontWeight: '700', textAlign: 'center', fontFamily: 'Poppins' }}>
                                                {item.free == true ? <text style={{ color: 'white' }}>Free</text> : 'Already Licensed'}
                                            </text>}
                                        </div>}



                                </div>


                            </div>)}
                        </div>

                        <div style={{ width: 0.74 * width, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 10, overflowY: 'auto', overflowX: 'hidden', }}>
                            <div style={{ width: 0.74 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 10 }}>


                                <div style={{ display: 'flex', height: 56, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>
                                    </div>
                                </div>


                                <div style={{ display: 'flex', height: 56, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>

                                    </div>
                                </div>


                                <div style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>

                                    </div>
                                </div>


                                <div style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.07 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                                        <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>Total: £{(quantity() * 12).toFixed(2)}</text>
                                    </div>
                                </div>

                                <div style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.07 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>

                                    </div>
                                </div>


                            </div>
                        </div>

                        <div style={{ width: 0.74 * width, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 10, overflowY: 'auto', overflowX: 'hidden', }}>
                            <div style={{ width: 0.74 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 10 }}>


                                <div style={{ display: 'flex', height: 56, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>
                                    </div>
                                </div>


                                <div style={{ display: 'flex', height: 56, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>

                                    </div>
                                </div>


                                <div style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>

                                    </div>
                                </div>


                                <div style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>
                                    <div onClick={() => {
                                        if (quantity() > 0) gettingSecret()
                                        else { toast('Please select devices') }
                                    }} style={{ cursor: 'pointer', opacity: quantity() > 0 ? 1 : 0.6, display: 'flex', height: 46, width: 0.07 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#F7941D', borderRadius: 5 }}>

                                        <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>Checkout</text>
                                    </div>
                                </div>

                                <div style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.07 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '', borderRadius: 5 }}>

                                    </div>
                                </div>


                            </div>
                        </div>

                    </div>
                </Collapsible>

            </div>

            <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 550, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'center' } }}
                isOpen={add}
                onRequestClose={() => {
                    setAdd(false); setSuccess(false); setId('')
                    setId2('')
                    setId3('')
                    setName('')
                }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '85%', alignSelf: 'center' }}>
                        <text></text>
                        <text style={{ fontWeight: '800', fontSize: 26, color: '#3AB549' }}>{success ? `Added successfully.` : null}</text>
                        <IoIosCloseCircle onClick={() => {
                            setAdd(false); setSuccess(false); setId('')
                            setId2('')
                            setId3('')
                            setName('')
                        }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />
                    </div>
                    {!success ? <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center' }}>
                        <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 24, fontFamily: "Open Sans", }}>Add New Device </text></div>
                        <text style={{ width: 500, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: 'white', marginTop: 20, fontFamily: "Open Sans", }}>ID Number</text>
                        <div style={{ width: 500, alignSelf: 'center', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>
                            <input placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 150, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 20, textAlign: 'center', fontFamily: "Open Sans", }} type="text" value={id} onChange={(e) => setId(e.target.value)} />
                            <input ref={ref2} placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 150, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 20, textAlign: 'center', fontFamily: "Open Sans", }} type="text" value={id2} onChange={(e) => setId2(e.target.value)} />
                            <input ref={ref3} placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 150, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 20, textAlign: 'center', fontFamily: "Open Sans", }} type="text" value={id3} onChange={(e) => setId3(e.target.value)} />

                        </div>
                        <text style={{ width: 500, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: 'white', marginTop: 20, fontFamily: "Open Sans", }}>Name</text>
                        <input ref={ref1} placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 480, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 17, fontFamily: "Open Sans", paddingLeft: 10 }} type="text" value={name} onChange={(e) => setName(e.target.value)} />


                        <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => add_device()} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: 5, outline: 'none', marginTop: 30, width: 485, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 22, fontFamily: "Open Sans", }}>Submit</text> </div>
                    </div> : <img src={require('../assets/successfull.png')} style={{ width: 300, alignSelf: 'center', height: 300 }} />}
                </div>
            </ReactModal>



            {delete_content != false ? <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 530) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 260, justifyContent: 'center' } }}
                isOpen={delete_content}
                onRequestClose={() => { setDeleteContent(false) }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                    <IoIosCloseCircle onClick={() => setDeleteContent(false)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                    <div style={{ display: 'flex', flexDirection: 'column', width: '75%', justifyContent: 'center', alignContent: 'center', marginTop: 0 }}>
                        <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', cursor: 'pointer' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 20 }}>{`Are you sure to delete ${decrypt(delete_content.name)} device ?`}</text></div>

                        <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: 400, justifyContent: 'space-around', marginTop: 40, cursor: 'pointer' }}>
                            <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => delet_content()} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', width: 130, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Yes</text> </div>
                            <div onClick={() => setDeleteContent(false)} style={{ height: 40, width: 130, backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 5, padding: 5 }}>
                                <text style={{ fontWeight: '600', fontSize: 15, color: 'white' }}>No</text>
                            </div>
                        </div>
                    </div>
                </div>
            </ReactModal> : null}

            {delete_subscribe != null ? <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: 100, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 260, justifyContent: 'center' } }}
                isOpen={delete_subscribe != null}
                onRequestClose={() => { setDeleteSubscribe(null) }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                    <IoIosCloseCircle onClick={() => setDeleteSubscribe(null)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                    <div style={{ display: 'flex', flexDirection: 'column', width: '75%', justifyContent: 'center', alignContent: 'center', marginTop: 0 }}>
                        <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', cursor: 'pointer' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 20 }}>{`Are you sure to delete license ?`}</text></div>

                        <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: 400, justifyContent: 'space-around', marginTop: 40, cursor: 'pointer' }}>
                            <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => remove_pay(delete_subscribe.device)} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', width: 130, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Yes</text> </div>
                            <div onClick={() => { setDeleteSubscribe(null) }} style={{ height: 40, width: 130, backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 5, padding: 5 }}>
                                <text style={{ fontWeight: '600', fontSize: 15, color: 'white' }}>No</text>
                            </div>
                        </div>
                    </div>
                </div>
            </ReactModal> : null}



            <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 550) / 2, display: 'flex', backgroundColor: '#111417', width: 550, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'flex-start' } }}
                isOpen={add_feed}
                onRequestClose={() => {
                    setAdd_feed(false);

                }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'flex-start', alignItems: 'center', alignContent: 'center', marginTop: 30 }}>

                    <IoIosCloseCircle onClick={() => {
                        setAdd_feed(false);
                    }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />


                    <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 24, fontFamily: "Open Sans", }}>Feedback</text></div>

                    <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', width: 480, marginTop: 50 }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 18, fontFamily: "Open Sans", }}>Tell us about your problems</text></div>
                    <input placeholder='Write here' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 470, backgroundColor: '#ECFEFD', outline: 'none', height: 130, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 17, fontFamily: "Open Sans", paddingLeft: 10, verticalAlign: 'text-top' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />
                    <div style={{ display: 'flex', height: 40, width: 480, justifyContent: 'center', alignContent: 'center', alignItems: 'center', alignSelf: 'center', marginTop: 40, backgroundColor: '#F7941D', borderWidth: 1, borderColor: '#26B8AD', borderStyle: 'solid', borderRadius: 10 }}><text style={{ textAlign: 'center', color: '#000000', fontWeight: '700', fontSize: 24, fontFamily: "Open Sans", }}>Submit</text>
                    </div>

                </div>
            </ReactModal>



            <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', bottom: '80%' }, content: { display: 'flex', position: 'absolute', top: '5%', left: '25%', display: 'flex', backgroundColor: '#111417', width: '50%', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 650, justifyContent: 'center' } }}
                isOpen={payment}
                onRequestClose={() => { setPayment(false) }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ width: 450, display: 'flex', flexDirection: 'column', alignSelf: 'center', justifyContent: 'center', marginTop: 20 }}>
                    <text style={{ textAlign: 'center', color: '#00186D', fontSize: 20, fontWeight: '700', fontFamily: 'VisbyBold', marginTop: 35 }}></text>

                    <text style={{ textAlign: 'center', color: 'white', fontSize: 25, fontWeight: '700', fontFamily: 'VisbyBold', marginTop: 45, marginBottom: 10 }}>Subscription Total £{(Exactquantity() * 12).toFixed(2)}</text>
                    {stripePromise && clientSecret && (
                        <Elements stripe={stripePromise} options={{
                            clientSecret, appearance: {
                                theme: 'night',
                                labels: 'floating',
                                variables: {
                                    colorPrimary: 'black',
                                    colorBackground: 'white',
                                    colorText: '#30313d',
                                    borderRadius: '0px',
                                },
                                rules: {
                                    '.Tab': {
                                        border: '0px solid #FFFFFF',
                                        boxShadow: '0px 0px 0px rgba(0, 0, 0, 0.03), 0px 0px 0px #FFFFFF',
                                        outline: 'none'
                                    },

                                    '.Tab:hover': {
                                        color: 'var(--colorText)',
                                    },

                                    '.Tab--selected': {
                                        borderColor: '#E0E6EB',
                                        border: 'none',
                                        outline: 'none'
                                    },

                                    '.Input': {
                                        boxShadow: 'inset 0 0 px rgb(209,213,219)',
                                        outline: 'none',
                                        padding: '0.75em 1em',
                                        color: 'black'
                                    },

                                    '.Input:focus': {
                                        boxShadow: 'inset 0 0 px rgb(209,213,219)',

                                        outline: 'none',
                                        padding: '0.75em 1em',
                                        color: 'black'
                                    },

                                    '.Input--invalid': {
                                        boxShadow: '0 0px 0px 0 #FFFFFF, 0 0 0 0px var(--colorDanger)',
                                        outline: 'none'
                                    },

                                    // See all supported class names and selector syntax below
                                }
                            },
                        }}>
                            <CheckoutForm price={(Exactquantity() * 12).toFixed(2)} done={make_payment} text={'Make Payment'} check={true} />
                        </Elements>
                    )}

                    {!payment_loading ? <div style={{ width: 420, display: 'flex', alignSelf: 'center', justifyContent: 'right', alignItems: 'center', marginBottom: 15, marginTop: 15 }}>

                    </div> :
                        <div style={{ display: 'flex', alignSelf: 'center', justifyContent: 'center', alignItems: 'center' }}> <RiseLoader color={button_color} isLoading={true}
                            css={override} size={20} />
                        </div>}
                </div>
            </ReactModal>


            <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', bottom: '80%' }, content: { display: 'flex', position: 'absolute', top: '5%', left: '25%', display: 'flex', backgroundColor: '#111417', width: '50%', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 650, justifyContent: 'center' } }}
                isOpen={delete_pay}
                onRequestClose={() => { setDeletePay(false) }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ width: 450, display: 'flex', flexDirection: 'column', alignSelf: 'center', justifyContent: 'center', marginTop: 20 }}>
                    <text style={{ textAlign: 'center', color: '#00186D', fontSize: 20, fontWeight: '700', fontFamily: 'VisbyBold', marginTop: 35 }}></text>

                    <text style={{ textAlign: 'center', color: 'white', fontSize: 25, fontWeight: '700', fontFamily: 'VisbyBold', marginTop: 45, marginBottom: 10 }}>Update Subscription Total £{currentAmount()}</text>
                    {stripePromise && clientSecret && (
                        <Elements stripe={stripePromise} options={{
                            clientSecret, appearance: {
                                theme: 'night',
                                labels: 'floating',
                                variables: {
                                    colorPrimary: 'black',
                                    colorBackground: 'white',
                                    colorText: '#30313d',
                                    borderRadius: '0px',
                                },
                                rules: {
                                    '.Tab': {
                                        border: '0px solid #FFFFFF',
                                        boxShadow: '0px 0px 0px rgba(0, 0, 0, 0.03), 0px 0px 0px #FFFFFF',
                                        outline: 'none'
                                    },

                                    '.Tab:hover': {
                                        color: 'var(--colorText)',
                                    },

                                    '.Tab--selected': {
                                        borderColor: '#E0E6EB',
                                        border: 'none',
                                        outline: 'none'
                                    },

                                    '.Input': {
                                        boxShadow: 'inset 0 0 px rgb(209,213,219)',
                                        outline: 'none',
                                        padding: '0.75em 1em',
                                        color: 'black'
                                    },

                                    '.Input:focus': {
                                        boxShadow: 'inset 0 0 px rgb(209,213,219)',

                                        outline: 'none',
                                        padding: '0.75em 1em',
                                        color: 'black'
                                    },

                                    '.Input--invalid': {
                                        boxShadow: '0 0px 0px 0 #FFFFFF, 0 0 0 0px var(--colorDanger)',
                                        outline: 'none'
                                    },

                                    // See all supported class names and selector syntax below
                                }
                            },
                        }}>
                            <CheckoutForm price={currentAmount()} done={make_payment_delete} text={'Make Payment'} check={true} />
                        </Elements>
                    )}

                    {!payment_loading ? <div style={{ width: 420, display: 'flex', alignSelf: 'center', justifyContent: 'right', alignItems: 'center', marginBottom: 15, marginTop: 15 }}>

                    </div> :
                        <div style={{ display: 'flex', alignSelf: 'center', justifyContent: 'center', alignItems: 'center' }}> <RiseLoader color={button_color} isLoading={true}
                            css={override} size={20} />
                        </div>}
                </div>
            </ReactModal>

            <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', bottom: '80%' }, content: { display: 'flex', position: 'absolute', top: '5%', left: '25%', display: 'flex', backgroundColor: '#111417', width: '50%', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 650, justifyContent: 'center' } }}
                isOpen={add_pay}
                onRequestClose={() => { setAddPay(false) }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ width: 450, display: 'flex', flexDirection: 'column', alignSelf: 'center', justifyContent: 'center', marginTop: 20 }}>
                    <text style={{ textAlign: 'center', color: '#00186D', fontSize: 20, fontWeight: '700', fontFamily: 'VisbyBold', marginTop: 35 }}></text>

                    <text style={{ textAlign: 'center', color: 'white', fontSize: 25, fontWeight: '700', fontFamily: 'VisbyBold', marginTop: 45, marginBottom: 10 }}>Update Subscription Total £{currentAmountAdd()}</text>
                    {stripePromise && clientSecret && (
                        <Elements stripe={stripePromise} options={{
                            clientSecret, appearance: {
                                theme: 'night',
                                labels: 'floating',
                                variables: {
                                    colorPrimary: 'black',
                                    colorBackground: 'white',
                                    colorText: '#30313d',
                                    borderRadius: '0px',
                                },
                                rules: {
                                    '.Tab': {
                                        border: '0px solid #FFFFFF',
                                        boxShadow: '0px 0px 0px rgba(0, 0, 0, 0.03), 0px 0px 0px #FFFFFF',
                                        outline: 'none'
                                    },

                                    '.Tab:hover': {
                                        color: 'var(--colorText)',
                                    },

                                    '.Tab--selected': {
                                        borderColor: '#E0E6EB',
                                        border: 'none',
                                        outline: 'none'
                                    },

                                    '.Input': {
                                        boxShadow: 'inset 0 0 px rgb(209,213,219)',
                                        outline: 'none',
                                        padding: '0.75em 1em',
                                        color: 'black'
                                    },

                                    '.Input:focus': {
                                        boxShadow: 'inset 0 0 px rgb(209,213,219)',

                                        outline: 'none',
                                        padding: '0.75em 1em',
                                        color: 'black'
                                    },

                                    '.Input--invalid': {
                                        boxShadow: '0 0px 0px 0 #FFFFFF, 0 0 0 0px var(--colorDanger)',
                                        outline: 'none'
                                    },

                                    // See all supported class names and selector syntax below
                                }
                            },
                        }}>
                            <CheckoutForm price={currentAmountAdd()} done={add_new} text={'Make Payment'} check={true} />
                        </Elements>
                    )}

                    {!payment_loading ? <div style={{ width: 420, display: 'flex', alignSelf: 'center', justifyContent: 'right', alignItems: 'center', marginBottom: 15, marginTop: 15 }}>

                    </div> :
                        <div style={{ display: 'flex', alignSelf: 'center', justifyContent: 'center', alignItems: 'center' }}> <RiseLoader color={button_color} isLoading={true}
                            css={override} size={20} />
                        </div>}
                </div>
            </ReactModal>


            <wc-toast></wc-toast>

            <text style={{ fontSize: 16, color: 'white', fontWeight: '600', position: 'absolute', bottom: 10, left: 10, letterSpacing: 1.01 }}>Version 1.7</text>

        </div> : <div style={{ backgroundColor: '#080A0C', display: 'flex', flexDirection: 'row', width: width, height: height, position: 'absolute', top: 0, left: 0 }}>


            <div className={drawerClasses} style={{ width: drawerW }}>

                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#080A0C", width: drawerW, height: 60, justifyContent: 'center', alignItems: 'center' }}>
                    <img
                        src={logo}
                        alt="Logo"
                        style={{ width: 113, marginTop: 1, height: 53, alignSelf: 'center' }}
                    />

                </div>

                {/* CONTENT */}
                {items.show_welcome ? <div onClick={() => navigate('/Welcome')} style={{ cursor: 'pointer', marginTop: 10, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Welcome</text>
                        <div style={{ height: 30, width: 20 }} />
                    </div>
                </div> : null}

                {/* DEVICES */}
                <div onClick={() => navigate('/Devices')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Devices</text>
                        <div style={{ height: 30, width: 20 }} />
                    </div>
                </div>

                {/* CONTENT */}
                <div onClick={() => navigate('/Content')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Content</text>
                        <div style={{ height: 30, width: 20 }} />
                    </div>
                </div>


                {/* CALENDAR */}
                <div onClick={() => navigate('/Calendars')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Calendar</text>
                        <div style={{ height: 30, width: 20 }} />
                    </div>
                </div>

                <div onClick={() => navigate('/AIGenerator')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>AI Generator</text>
                        <div style={{ height: 30, width: 20 }} />
                    </div>
                </div>

                <div style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW - 30, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30 }}>
                    <div style={{ position: 'relative', backgroundColor: '#181E25', width: drawerW - 42, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 30, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 32) - 46)}>Subscription</text>
                        <img src={require('../assets/right.png')} style={{ height: 30, width: 20 }} />
                        {items.unlicensed > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: 'red', top: 5, left: 5 }}>
                            <text style={{ color: 'red', fontSize: 13 }}>{items.unlicensed}</text>
                        </div>}
                        {items.trial > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: '#F7941D', top: 5, right: 20 }}>
                            <text style={{ color: '#F7941D', fontSize: 13 }}>{items.trial}</text>
                        </div>}

                    </div>
                </div>

                {/* SETTINGS */}
                <div onClick={() => navigate('/Settings')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
                    <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 30, alignItems: 'center', justifyContent: 'space-between' }}>
                        <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Settings</text>
                        <div style={{ height: 30, width: 20 }} />
                    </div>
                </div>

                <div onClick={() => {
                    navigate('/')
                    localStorage.removeItem('display')
                    localStorage.removeItem('devices')
                    SetId(null)
                }} style={{ left: ((0.35 * width) - 100) / 2, position: 'absolute', bottom: 90, alignContent: 'center', cursor: 'pointer', alignSelf: 'center', width: 150, height: 36, borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderWidth: 1, borderStyle: 'solid', borderColor: '#F7941D' }}>
                    <text style={{ color: '#F7941D', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Log out</text>
                </div>

            </div>

            {drawerOpen && <BackDrop closeDrawer={handleBackdropClick} />}




            <div style={{ display: 'flex', flexDirection: 'column', width: width, position: 'absolute', top: 0, height: height, backgroundColor: '#181E25', alignItems: 'flex-end' }}>

                <div style={{ display: 'flex', height: 100, width: width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C' }}>

                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: (width * 0.94) - 5 }}>
                        <div style={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <VscThreeBars size={30} color='white' onClick={handleOpenDrawerButton} />
                        </div>
                        <div style={{ marginLeft: 6, marginTop: 4 }}>
                            <stripe-buy-button
                                buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                                publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
                            >
                            </stripe-buy-button>
                        </div>
                    </div>

                </div>


                <Collapsible transitionTime={500} open={all_payment == false}>
                    <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#181E25', width: width, height: height - 100 }}>


                        <div style={{ width: 0.94 * width, minHeight: 65, height: 120, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 20, backgroundColor: '#F7941D', borderRadius: 12 }}>


                            <div style={{ width: 0.93 * width, height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', }}>

                                <div style={{ width: 0.93 * width, height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginLeft: 10 }}>

                                    <div style={{ borderRadius: 10, backgroundColor: '#FFFFFF', cursor: 'pointer', display: 'flex', width: 0.90 * width, height: 46, justifyContent: 'space-around', alignItems: 'center', alignSelf: 'center' }}>
                                        <text style={{ fontWeight: '700', fontSize: 16, color: 'black' }}>{licenses} License{`(s)`} Available</text>
                                        <div style={{ height: 28, width: 2, backgroundColor: 'black' }} />
                                        <text style={{ fontWeight: '700', fontSize: 16, color: 'black' }}>{number_of_used()} License{`(s)`} Used</text>
                                    </div>

                                </div>


                            </div>

                            <div style={{ marginBottom: 4, width: 0.92 * width, height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', alignSelf: 'center', marginTop: 6, marginLeft: 10 }}>

                                <div onClick={() => {

                                    if (licenses > 0) {
                                        getUrl()
                                        // window.open('https://billing.stripe.com/p/login/test_7sY9AV3Mc3VZdUb2Uk7Zu00', 'mywindow').focus()
                                    }
                                    else {

                                        window.location.replace('https://buy.stripe.com/fZu9ATcsr6QE6XUgbLcQU01', 'mywindow')
                                    }

                                }} style={{ cursor: 'pointer', display: 'flex', width: 150, height: 46, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>

                                    <text style={{ fontWeight: '600', fontSize: 12, color: 'black' }}>{licenses > 0 ? 'Manage' : 'Purchase'} Subscriptions</text>
                                </div>



                            </div>
                        </div>




                        <div style={{ width: 0.94 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 20 }}>


                            <div style={{ display: 'flex', height: 51, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                <div style={{ display: 'flex', height: 51, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                                    <text style={{ color: 'white', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Device Name</text>
                                </div>
                            </div>


                            <div style={{ display: 'flex', height: 51, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                <div style={{ display: 'flex', height: 51, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                                    <text style={{ color: 'white', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>ID Number</text>
                                </div>
                            </div>


                            <div style={{ display: 'flex', height: 51, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                <div style={{ display: 'flex', height: 51, width: 0.10 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                                    <text style={{ color: 'white', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Last Online</text>
                                </div>
                            </div>



                            <div style={{ display: 'flex', height: 51, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                <div style={{ display: 'flex', height: 51, width: 0.07 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5, wordBreak: 'break-all' }}>

                                    <text style={{ color: 'white', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>License</text>
                                </div>
                            </div>

                            <div style={{ display: 'flex', height: 51, width: 0.18 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
                                <div style={{ display: 'flex', height: 51, width: 0.16 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5, wordBreak: 'break-all' }}>

                                    <text style={{ color: 'white', fontSize: 14, fontWeight: '600', textAlign: 'center' }}> Subscription</text>
                                </div>
                            </div>
                        </div>



                        <div style={{ width: 0.94 * width, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 0, overflowY: 'auto', maxHeight: 1200, overflowX: 'hidden', }}>
                            {devices.map((item, id) => <div style={{ width: 0.94 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 10 }}>


                                <div style={{ display: 'flex', height: 56, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                                        <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{item.name != undefined ? decrypt(item.name) : null}</text>
                                    </div>
                                </div>


                                <div style={{ display: 'flex', height: 56, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                                        <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{item.device}</text>
                                    </div>
                                </div>


                                <div style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                    <div style={{ display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                        <div style={{ width: 16, height: 16, borderRadius: 10, backgroundColor: lastActiveColor(item.last) }} />
                                        <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'left', alignSelf: 'center', marginLeft: 6 }}>{lastActive(Number(item.last))}</text>

                                    </div>
                                </div>


                                <div style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                    <div onClick={() => {
                                        if (item.free == false || item.free == undefined) {
                                            if (item.pay == true) {
                                                // remove_pay(item.device)
                                                setDeleteSubscribe(item)
                                            }
                                            else {
                                                add_pay_checked(item.device)
                                            }
                                        }
                                        else {
                                            toast('This one is free')
                                        }
                                    }} style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.07 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                                        <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{(item.pay == true || item.free == true) ? <GoCheckbox size={25} color='#3ab549' /> : <FaRegSquare size={25} color='#F7941D' />}</text>
                                    </div>
                                </div>

                                <div onClick={() => { }} style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.18 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                                    {thirtydaysends(item.device) >= 7 * 1440 ? <div style={{ display: 'flex', height: 56, width: 0.16 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                                        {((item.free == undefined || item.free == false) && (item.pay == undefined || item.pay == false)) ? <text style={{ color: 'red', fontWeight: '800', fontSize: 12 }}>Unlicensed</text>
                                            : <text style={{ color: '#F7941D', fontSize: 12, fontWeight: '700', textAlign: 'center', fontFamily: 'Poppins' }}>
                                                {item.free == true ? <text style={{ color: '#3ab549', fontWeight: '800', fontSize: 13 }}>Free</text> :

                                                    <text style={{ color: '#3ab549', fontWeight: '800', fontSize: 13, marginRight: 4, alignSelf: 'flex-start', textAlign: 'left' }}>Licensed</text>

                                                }
                                            </text>}
                                    </div>

                                        : <div style={{ display: 'flex', height: 56, width: 0.16 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>



                                            {((item.free == undefined || item.free == false) && (item.pay == undefined || item.pay == false)) ? <div onClick={() => { }} style={{ cursor: 'pointer', alignSelf: 'center', width: 125, height: 36, borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderWidth: 0, borderStyle: 'solid', borderColor: '#F7941D', marginLeft: 5 }}>

                                                {(item.pay == undefined || item.pay == false) && <text style={{ color: '#F7941D', fontSize: 13, fontWeight: '700', textAlign: 'center', fontFamily: 'Poppins' }}>
                                                    Trial - {trialends(item.device)} left
                                                </text>}

                                            </div> : <text style={{ color: '#F7941D', fontSize: 12, fontWeight: '700', textAlign: 'center', fontFamily: 'Poppins' }}>
                                                {item.free == true ? <text style={{ color: '#3ab549', fontWeight: '800', fontSize: 12 }}>Free</text> : <div style={{ cursor: 'pointer', alignSelf: 'center', width: 105, height: 36, borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderWidth: 1, borderStyle: 'solid', borderColor: '#F7941D', marginLeft: 5 }}>
                                                    <text style={{ color: '#F7941D', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>Delete</text>
                                                </div>}
                                            </text>}
                                        </div>}

                                </div>

                            </div>)}
                        </div>


                    </div>
                </Collapsible>

            </div>

            {!isMobile && <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 550, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'center' } }}
                isOpen={add}
                onRequestClose={() => {
                    setAdd(false); setSuccess(false); setId('')
                    setId2('')
                    setId3('')
                    setName('')
                }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '85%', alignSelf: 'center' }}>
                        <text></text>
                        <text style={{ fontWeight: '800', fontSize: 26, color: '#3AB549' }}>{success ? `Added successfully.` : null}</text>
                        <IoIosCloseCircle onClick={() => {
                            setAdd(false); setSuccess(false); setId('')
                            setId2('')
                            setId3('')
                            setName('')
                        }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />
                    </div>
                    {!success ? <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center' }}>
                        <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 24, fontFamily: "Open Sans", }}>Add New Device </text></div>
                        <text style={{ width: 500, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: 'white', marginTop: 20, fontFamily: "Open Sans", }}>ID Number</text>
                        <div style={{ width: 500, alignSelf: 'center', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>
                            <input placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 150, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 20, textAlign: 'center', fontFamily: "Open Sans", }} type="text" value={id} onChange={(e) => setId(e.target.value)} />
                            <input ref={ref2} placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 150, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 20, textAlign: 'center', fontFamily: "Open Sans", }} type="text" value={id2} onChange={(e) => setId2(e.target.value)} />
                            <input ref={ref3} placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 150, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 20, textAlign: 'center', fontFamily: "Open Sans", }} type="text" value={id3} onChange={(e) => setId3(e.target.value)} />

                        </div>
                        <text style={{ width: 500, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: 'white', marginTop: 20, fontFamily: "Open Sans", }}>Name</text>
                        <input ref={ref1} placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 480, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 17, fontFamily: "Open Sans", paddingLeft: 10 }} type="text" value={name} onChange={(e) => setName(e.target.value)} />


                        <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => add_device()} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: 5, outline: 'none', marginTop: 30, width: 485, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 22, fontFamily: "Open Sans", }}>Submit</text> </div>
                    </div> : <img src={require('../assets/successfull.png')} style={{ width: 300, alignSelf: 'center', height: 300 }} />}
                </div>
            </ReactModal>}



            {isMobile && add != false &&
                <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 330, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 150, left: (width - 330) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, borderWidth: 2, borderColor: 'white', borderStyle: 'solid' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '85%', alignSelf: 'center' }}>
                        <text></text>
                        <text style={{ fontWeight: '800', fontSize: 26, color: '#3AB549' }}>{success ? `Added successfully.` : null}</text>
                        <IoIosCloseCircle onClick={() => {
                            setAdd(false); setSuccess(false); setId('')
                            setId2('')
                            setId3('')
                            setName('')
                        }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />
                    </div>
                    {!success ? <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center' }}>
                        <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 24, fontFamily: "Open Sans", }}>Add New Device </text></div>
                        <text style={{ width: 320, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: 'white', marginTop: 20, fontFamily: "Open Sans", }}>ID Number</text>
                        <div style={{ width: 320, alignSelf: 'center', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>
                            <input placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 90, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 16, textAlign: 'center', fontFamily: "Open Sans" }} type="text" value={id} onChange={(e) => setId(e.target.value)} />
                            <input ref={ref2} placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 90, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 16, textAlign: 'center', fontFamily: "Open Sans", }} type="text" value={id2} onChange={(e) => setId2(e.target.value)} />
                            <input ref={ref3} placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 90, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 16, textAlign: 'center', fontFamily: "Open Sans", }} type="text" value={id3} onChange={(e) => setId3(e.target.value)} />

                        </div>
                        <text style={{ width: 320, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: 'white', marginTop: 20, fontFamily: "Open Sans", }}>Name</text>
                        <input ref={ref1} placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 310, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 17, fontFamily: "Open Sans", paddingLeft: 10 }} type="text" value={name} onChange={(e) => setName(e.target.value)} />


                        <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => add_device()} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: 5, outline: 'none', marginTop: 30, width: 310, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 22, fontFamily: "Open Sans", }}>Submit</text> </div>
                    </div> : <img src={require('../assets/successfull.png')} style={{ width: 300, alignSelf: 'center', height: 300 }} />}
                </div>
            }




            {!isMobile && delete_content != false ? <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 530) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 260, justifyContent: 'center' } }}
                isOpen={delete_content}
                onRequestClose={() => { setDeleteContent(false) }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                    <IoIosCloseCircle onClick={() => setDeleteContent(false)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                    <div style={{ display: 'flex', flexDirection: 'column', width: '75%', justifyContent: 'center', alignContent: 'center', marginTop: 0 }}>
                        <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', cursor: 'pointer' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 20 }}>{`Are you sure to delete ${decrypt(delete_content.name)} device ?`}</text></div>

                        <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: 400, justifyContent: 'space-around', marginTop: 40, cursor: 'pointer' }}>
                            <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => delet_content()} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', width: 130, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Yes</text> </div>
                            <div onClick={() => setDeleteContent(false)} style={{ height: 40, width: 130, backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 5, padding: 5 }}>
                                <text style={{ fontWeight: '600', fontSize: 15, color: 'white' }}>No</text>
                            </div>
                        </div>
                    </div>
                </div>
            </ReactModal> : null}



            {isMobile && delete_content != false &&
                <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 330, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 150, left: (width - 330) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, borderWidth: 2, borderColor: 'white', borderStyle: 'solid' }}>

                    <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                        <IoIosCloseCircle onClick={() => setDeleteContent(false)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                        <div style={{ display: 'flex', flexDirection: 'column', width: '75%', justifyContent: 'center', alignContent: 'center', marginTop: 0 }}>
                            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', cursor: 'pointer' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 20 }}>{`Are you sure to delete ${decrypt(delete_content.name)} device ?`}</text></div>

                            <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: 400, justifyContent: 'space-around', marginTop: 40, cursor: 'pointer' }}>
                                <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => delet_content()} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', width: 130, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Yes</text> </div>
                                <div onClick={() => setDeleteContent(false)} style={{ height: 40, width: 130, backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 5, padding: 5 }}>
                                    <text style={{ fontWeight: '600', fontSize: 15, color: 'white' }}>No</text>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}





            {!isMobile && delete_subscribe != null ? <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: 100, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 260, justifyContent: 'center' } }}
                isOpen={delete_subscribe != null}
                onRequestClose={() => { setDeleteSubscribe(null) }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                    <IoIosCloseCircle onClick={() => setDeleteSubscribe(null)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                    <div style={{ display: 'flex', flexDirection: 'column', width: '75%', justifyContent: 'center', alignContent: 'center', marginTop: 0 }}>
                        <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', cursor: 'pointer' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 20 }}>{`Are you sure to delete license ?`}</text></div>

                        <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: 400, justifyContent: 'space-around', marginTop: 40, cursor: 'pointer' }}>
                            <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => remove_pay(delete_subscribe.device)} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', width: 130, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Yes</text> </div>
                            <div onClick={() => { setDeleteSubscribe(null) }} style={{ height: 40, width: 130, backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 5, padding: 5 }}>
                                <text style={{ fontWeight: '600', fontSize: 15, color: 'white' }}>No</text>
                            </div>
                        </div>
                    </div>
                </div>
            </ReactModal> : null}

            {isMobile && delete_subscribe != null &&
                <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 330, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 150, left: (width - 330) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 300, borderWidth: 2, borderColor: 'white', borderStyle: 'solid' }}>

                    <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

                        <IoIosCloseCircle onClick={() => setDeleteSubscribe(null)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

                        <div style={{ display: 'flex', flexDirection: 'column', width: '75%', justifyContent: 'center', alignContent: 'center', marginTop: 0 }}>
                            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', cursor: 'pointer' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 20 }}>{`Are you sure to delete license ?`}</text></div>

                            <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: 300, justifyContent: 'space-around', marginTop: 40, cursor: 'pointer' }}>
                                <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => remove_pay(delete_subscribe.device)} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', width: 130, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Yes</text> </div>
                                <div onClick={() => { setDeleteSubscribe(null) }} style={{ height: 40, width: 130, backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 5, padding: 5 }}>
                                    <text style={{ fontWeight: '600', fontSize: 15, color: 'white' }}>No</text>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }


            <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', bottom: '80%' }, content: { display: 'flex', position: 'absolute', top: '5%', left: '25%', display: 'flex', backgroundColor: '#111417', width: '50%', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 650, justifyContent: 'center' } }}
                isOpen={payment}
                onRequestClose={() => { setPayment(false) }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ width: 450, display: 'flex', flexDirection: 'column', alignSelf: 'center', justifyContent: 'center', marginTop: 20 }}>
                    <text style={{ textAlign: 'center', color: '#00186D', fontSize: 20, fontWeight: '700', fontFamily: 'VisbyBold', marginTop: 35 }}></text>

                    <text style={{ textAlign: 'center', color: 'white', fontSize: 25, fontWeight: '700', fontFamily: 'VisbyBold', marginTop: 45, marginBottom: 10 }}>Subscription Total £{(Exactquantity() * 12).toFixed(2)}</text>
                    {stripePromise && clientSecret && (
                        <Elements stripe={stripePromise} options={{
                            clientSecret, appearance: {
                                theme: 'night',
                                labels: 'floating',
                                variables: {
                                    colorPrimary: 'black',
                                    colorBackground: 'white',
                                    colorText: '#30313d',
                                    borderRadius: '0px',
                                },
                                rules: {
                                    '.Tab': {
                                        border: '0px solid #FFFFFF',
                                        boxShadow: '0px 0px 0px rgba(0, 0, 0, 0.03), 0px 0px 0px #FFFFFF',
                                        outline: 'none'
                                    },

                                    '.Tab:hover': {
                                        color: 'var(--colorText)',
                                    },

                                    '.Tab--selected': {
                                        borderColor: '#E0E6EB',
                                        border: 'none',
                                        outline: 'none'
                                    },

                                    '.Input': {
                                        boxShadow: 'inset 0 0 px rgb(209,213,219)',
                                        outline: 'none',
                                        padding: '0.75em 1em',
                                        color: 'black'
                                    },

                                    '.Input:focus': {
                                        boxShadow: 'inset 0 0 px rgb(209,213,219)',

                                        outline: 'none',
                                        padding: '0.75em 1em',
                                        color: 'black'
                                    },

                                    '.Input--invalid': {
                                        boxShadow: '0 0px 0px 0 #FFFFFF, 0 0 0 0px var(--colorDanger)',
                                        outline: 'none'
                                    },

                                    // See all supported class names and selector syntax below
                                }
                            },
                        }}>
                            <CheckoutForm price={(Exactquantity() * 12).toFixed(2)} done={make_payment} text={'Make Payment'} check={true} />
                        </Elements>
                    )}

                    {!payment_loading ? <div style={{ width: 420, display: 'flex', alignSelf: 'center', justifyContent: 'right', alignItems: 'center', marginBottom: 15, marginTop: 15 }}>

                    </div> :
                        <div style={{ display: 'flex', alignSelf: 'center', justifyContent: 'center', alignItems: 'center' }}> <RiseLoader color={button_color} isLoading={true}
                            css={override} size={20} />
                        </div>}
                </div>
            </ReactModal>


            <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', bottom: '80%' }, content: { display: 'flex', position: 'absolute', top: '5%', left: '25%', display: 'flex', backgroundColor: '#111417', width: '50%', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 650, justifyContent: 'center' } }}
                isOpen={delete_pay}
                onRequestClose={() => { setDeletePay(false) }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ width: 450, display: 'flex', flexDirection: 'column', alignSelf: 'center', justifyContent: 'center', marginTop: 20 }}>
                    <text style={{ textAlign: 'center', color: '#00186D', fontSize: 20, fontWeight: '700', fontFamily: 'VisbyBold', marginTop: 35 }}></text>

                    <text style={{ textAlign: 'center', color: 'white', fontSize: 25, fontWeight: '700', fontFamily: 'VisbyBold', marginTop: 45, marginBottom: 10 }}>Update Subscription Total £{currentAmount()}</text>
                    {stripePromise && clientSecret && (
                        <Elements stripe={stripePromise} options={{
                            clientSecret, appearance: {
                                theme: 'night',
                                labels: 'floating',
                                variables: {
                                    colorPrimary: 'black',
                                    colorBackground: 'white',
                                    colorText: '#30313d',
                                    borderRadius: '0px',
                                },
                                rules: {
                                    '.Tab': {
                                        border: '0px solid #FFFFFF',
                                        boxShadow: '0px 0px 0px rgba(0, 0, 0, 0.03), 0px 0px 0px #FFFFFF',
                                        outline: 'none'
                                    },

                                    '.Tab:hover': {
                                        color: 'var(--colorText)',
                                    },

                                    '.Tab--selected': {
                                        borderColor: '#E0E6EB',
                                        border: 'none',
                                        outline: 'none'
                                    },

                                    '.Input': {
                                        boxShadow: 'inset 0 0 px rgb(209,213,219)',
                                        outline: 'none',
                                        padding: '0.75em 1em',
                                        color: 'black'
                                    },

                                    '.Input:focus': {
                                        boxShadow: 'inset 0 0 px rgb(209,213,219)',

                                        outline: 'none',
                                        padding: '0.75em 1em',
                                        color: 'black'
                                    },

                                    '.Input--invalid': {
                                        boxShadow: '0 0px 0px 0 #FFFFFF, 0 0 0 0px var(--colorDanger)',
                                        outline: 'none'
                                    },

                                    // See all supported class names and selector syntax below
                                }
                            },
                        }}>
                            <CheckoutForm price={currentAmount()} done={make_payment_delete} text={'Make Payment'} check={true} />
                        </Elements>
                    )}

                    {!payment_loading ? <div style={{ width: 420, display: 'flex', alignSelf: 'center', justifyContent: 'right', alignItems: 'center', marginBottom: 15, marginTop: 15 }}>

                    </div> :
                        <div style={{ display: 'flex', alignSelf: 'center', justifyContent: 'center', alignItems: 'center' }}> <RiseLoader color={button_color} isLoading={true}
                            css={override} size={20} />
                        </div>}
                </div>
            </ReactModal>

            <ReactModal
                style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', bottom: '80%' }, content: { display: 'flex', position: 'absolute', top: '5%', left: '25%', display: 'flex', backgroundColor: '#111417', width: '50%', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 650, justifyContent: 'center' } }}
                isOpen={add_pay}
                onRequestClose={() => { setAddPay(false) }}
                closeTimeoutMS={100}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
            >
                <div style={{ width: 450, display: 'flex', flexDirection: 'column', alignSelf: 'center', justifyContent: 'center', marginTop: 20 }}>
                    <text style={{ textAlign: 'center', color: '#00186D', fontSize: 20, fontWeight: '700', fontFamily: 'VisbyBold', marginTop: 35 }}></text>

                    <text style={{ textAlign: 'center', color: 'white', fontSize: 25, fontWeight: '700', fontFamily: 'VisbyBold', marginTop: 45, marginBottom: 10 }}>Update Subscription Total £{currentAmountAdd()}</text>
                    {stripePromise && clientSecret && (
                        <Elements stripe={stripePromise} options={{
                            clientSecret, appearance: {
                                theme: 'night',
                                labels: 'floating',
                                variables: {
                                    colorPrimary: 'black',
                                    colorBackground: 'white',
                                    colorText: '#30313d',
                                    borderRadius: '0px',
                                },
                                rules: {
                                    '.Tab': {
                                        border: '0px solid #FFFFFF',
                                        boxShadow: '0px 0px 0px rgba(0, 0, 0, 0.03), 0px 0px 0px #FFFFFF',
                                        outline: 'none'
                                    },

                                    '.Tab:hover': {
                                        color: 'var(--colorText)',
                                    },

                                    '.Tab--selected': {
                                        borderColor: '#E0E6EB',
                                        border: 'none',
                                        outline: 'none'
                                    },

                                    '.Input': {
                                        boxShadow: 'inset 0 0 px rgb(209,213,219)',
                                        outline: 'none',
                                        padding: '0.75em 1em',
                                        color: 'black'
                                    },

                                    '.Input:focus': {
                                        boxShadow: 'inset 0 0 px rgb(209,213,219)',

                                        outline: 'none',
                                        padding: '0.75em 1em',
                                        color: 'black'
                                    },

                                    '.Input--invalid': {
                                        boxShadow: '0 0px 0px 0 #FFFFFF, 0 0 0 0px var(--colorDanger)',
                                        outline: 'none'
                                    },

                                    // See all supported class names and selector syntax below
                                }
                            },
                        }}>
                            <CheckoutForm price={currentAmountAdd()} done={add_new} text={'Make Payment'} check={true} />
                        </Elements>
                    )}

                    {!payment_loading ? <div style={{ width: 420, display: 'flex', alignSelf: 'center', justifyContent: 'right', alignItems: 'center', marginBottom: 15, marginTop: 15 }}>

                    </div> :
                        <div style={{ display: 'flex', alignSelf: 'center', justifyContent: 'center', alignItems: 'center' }}> <RiseLoader color={button_color} isLoading={true}
                            css={override} size={20} />
                        </div>}
                </div>
            </ReactModal>


            <wc-toast></wc-toast>

            <text style={{ fontSize: 16, color: 'white', fontWeight: '600', position: 'absolute', bottom: 10, left: 10, letterSpacing: 1.01 }}>Version 1.7</text>

        </div >
    );
}


const mapStateToProps = state => {
    //  console.log(state)
    return {
        items: state._todoProduct
    }
}

export default connect(mapStateToProps, { SetId })(Subscription)

/*

    <div style={{ marginLeft: 6, marginTop: 4 }}>
                            <stripe-buy-button
                                buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                                publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
                            >
                            </stripe-buy-button>
                        </div>
*/

